import { render, staticRenderFns } from "./RegChagasList.vue?vue&type=template&id=5fc7cc31"
import script from "./RegChagasList.vue?vue&type=script&lang=js"
export * from "./RegChagasList.vue?vue&type=script&lang=js"
import style0 from "./RegChagasList.vue?vue&type=style&index=0&id=5fc7cc31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports